import React, { Fragment } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const FaqContent = [
  {
    title: "What is web hosting?",
    desc: `It is an online service that allows you to publish your website files onto the internet. So, anyone who has access to the internet has access to your website. In practice, it usually refers to the service you get from different web hosting providers.`,
    expand: "a",
  },
  {
    title: "How do you weigh different criteria in your process?",
    desc: `Assign a relative weight to each criterion, based on how important that criterion is to the situation.`,
    expand: "b",
  },
  {
    title: "What can I use to build my website?",
    desc: `Although there are many ways to build a website, there are few that we find easiest like Wix, Squarespace, or Wordpress to create your site – it’s the best option for tech novices.
     But these sites are small scale, these can't handle enough traffic on your website. Then comes the advance technologies that we use like NextJS, ReactJS, ExpressJS, Java Springboot, PHP with standalone databases like MongoDB or SQL DB.
    How do we know? Well, we’ve been where you are right now. Since then, we’ve carried out years of research on building websites so that we can bring you the most accurate and relevant guidance to help you get your site up and off the ground. Why not contact us and give it a go for yourself ?`,
    expand: "c",
  },
  {
    title:
      "If I already have a website, can I migrate it latest technology frameworks?",
    desc: `It’s often good business: migrating to new technology can make the company more efficient, more profitable, and more competitive.
    While new technologies that solve age-old problems can be refreshing, it’s quite another thing to have a fully thought-out approach to implementing the technology.
    With years of experience on migration, we carry out the complete process in a very smooth and efficient manner`,
    expand: "d",
  },
  // {
  //   title: "How can I accept credit cards online?",
  //   desc: `They not only understand what I say but read between the lines and also give
  //       me ideas of my own.  technology is perfect for best business solutions.`,
  //   expand: "e",
  // },
];

const Faq = () => {
  return (
    <Fragment>
      <Accordion
        className="accordion-style-one"
        preExpanded={["d"]}
        allowZeroExpanded
      >
        {FaqContent.map((item, i) => (
          <AccordionItem className="accordion-item" key={i} uuid={item.expand}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <button className="accordion-button" type="button">
                  {item.title}
                </button>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="accordion-body fadeInUp">
              <p>{item.desc}</p>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Fragment>
  );
};

export default Faq;
